import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import URLS from "@api/constants/urls";
import { urlUtility } from "@repo/utilities/url.utility.ts";

interface IProductServiceProps extends ICommonServiceProps {
  showActiveOnly?: boolean;
}
//Get All products
export const useGetAllProductService = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
  showActiveOnly = false,
  filters = {},
}: IProductServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  // Query's
  const allProductsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.PRODUCTS,
      page,
      debouncedQuery,
      per_page,
      showActiveOnly,
      JSON.stringify(filters),
    ],

    queryFn: () => {
      const searchParams = {
        "filter[name]": debouncedQuery,
        page,
        per_page,
        include: "insurer,segment",
        ...(showActiveOnly && { "filter[is_active]": true }),
        ...filters,
      };
      return handleGlobalGetRequestQuery({
        url: URLS.PRODUCTS,
        searchParams,
      });
    },
    enabled: enableQuery,
  });

  return {
    services: { allProductsService },
    states: { searchQuery, setSearchQuery },
  };
};

// Get single product from url product-id query
export const useGetSingleProductService = ({ enableQuery = true }) => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const productId = urlQueries["product-id"] || urlQueries["product_id"]  || "";

  const singleProductService = useQuery({
    queryKey: [...CACHE_KEYS.SINGLE_PRODUCT, productId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.PRODUCTS}/${productId}`,
      }),
    enabled: enableQuery ? (productId ? true : false) : false,
  });

  return { singleProductService };
};
